import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {userEntitlementConflictChecker} from 'src/openapi/admin/apis/UserEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {EntitlementConflictRequest} from 'src/openapi/admin/models/EntitlementConflictRequest';

type Props = {
    userId: number,
    entitlementConflictRequest: EntitlementConflictRequest,
};

export const useGetUserEntitlementsConflicts = ({userId, entitlementConflictRequest}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        userEntitlementConflictChecker({userId, entitlementConflictRequest}),
    ), [userId, apiDispatch, entitlementConflictRequest]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
